import { useEffect } from 'react';

import { getAmpConfigFlags } from 'shared/config/amp-config';
import { useAssets, useGetUserProgramsQuery } from 'shared/api/retail';
import { useGetAquaUserLicensesQuery } from 'shared/api/aqua';
import { useGetOnboardingUserInfoQuery } from 'shared/api/onboarding';
import { useIsDistrictAdminUserCheck } from 'shared/lib/utils/';
import { AuthService } from 'shared/lib/keycloak';
import { useAppSelector } from 'shared/lib/redux';

export const useNavigationApiDataPassing = () => {
  const { rawUserAssets, isLoading: isUserAssetsLoading } = useAssets();

  const teacherBk = AuthService.getUserBk();

  const { data: userPrograms, isLoading: isUserProgramsLoading } =
    useGetUserProgramsQuery(teacherBk);

  const isDistrictAdminUser = useIsDistrictAdminUserCheck();

  const { data: aquaUserLicensesData, isLoading: isAquaQueryLoading } =
    useGetAquaUserLicensesQuery(undefined, {
      skip: !isDistrictAdminUser,
    });

  const hasError = useAppSelector(
    (state) =>
      state.onboarding.queries[`getOnboardingUserInfo("${teacherBk}")`]
        ?.status === 'rejected',
  );

  const { data: onboardingUserInfo, isLoading: isOnboardingUserInfoLoading } =
    useGetOnboardingUserInfoQuery(teacherBk, {
      skip: !teacherBk || hasError,
    });

  useEffect(() => {
    const { isNewNavigationEnabled } = getAmpConfigFlags();

    // @TODO: stop checking isNewNavigationEnabled after RFS 2025 (new nav release)
    if (isNewNavigationEnabled && window.AmpNavigationV2Module) {
      const { updateConfig } = window.AmpNavigationV2Module;

      updateConfig({
        apiData: {
          retail: {
            userPrograms: {
              data: userPrograms,
              isLoading: isUserProgramsLoading,
            },
            userAssets: {
              data: rawUserAssets,
              isLoading: isUserAssetsLoading,
            },
          },
          onboarding: {
            userInfo: {
              data: onboardingUserInfo,
              isLoading: isOnboardingUserInfoLoading,
            },
          },
          aquaApi: {
            userLicenses: {
              data: aquaUserLicensesData?.rawResponse,
              isLoading: isDistrictAdminUser === null || isAquaQueryLoading,
            },
          },
        },
      });
    }
  }, [
    userPrograms,
    isUserProgramsLoading,
    isUserAssetsLoading,
    onboardingUserInfo,
    isOnboardingUserInfoLoading,
    aquaUserLicensesData,
    isAquaQueryLoading,
    isDistrictAdminUser,
    rawUserAssets,
  ]);
};
